import Api from './Api';

export default {
    GetDailyReportList(payload) {
        return Api().post('/api/admin/v2/getdailysalesreports', payload);
    },
    GetAggregatorDailyReportList(payload){
        return Api().post('/api/admin/v2/getaggregatordailysalesreports', payload);
    },
    GetScreenWiseCollectionReport(payload) {
        return Api().post('/api/admin/v2/getscreenwisesalesreports', payload);
    },
    GetFilmWiseCollectionReport(payload) {
        return Api().post('/api/admin/v2/getfilmwisesalesreports', payload);
    },
    GetPerformanceReportList(payload) {
        return Api().post('/api/admin/v2/getperformancereports', payload);
    },
    getPerformanceReportAkil(payload) {
        return Api().post(`/api/admin/v2/getPermofanceReportV3`, payload);
      }
}


// WEBPACK FOOTER //
// ./src/services/ReportsService-v2.js